export default "__VITE_ASSET__DoLKljPZ__"